import { render } from "./UniqueKeyListReviewPage.vue?vue&type=template&id=545f2c7e&scoped=true"
import script from "./UniqueKeyListReviewPage.vue?vue&type=script&lang=js"
export * from "./UniqueKeyListReviewPage.vue?vue&type=script&lang=js"

import "./UniqueKeyListReviewPage.vue?vue&type=style&index=0&id=545f2c7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545f2c7e"]])

export default __exports__